<template>
  <v-content>
    <v-container>
      <div class="block text-center">
        <h1 class="head">Поздравления!</h1>
        <p class="pIcon">
          <i class="fas fa-comment-alt fa-spin iconSpin"></i>
        </p>
        <p class="successBody">Успешно направено запитване !<br /></p>
        <i class="iconTelInfo">За повече информация на тел. 0895-156-101</i>
      </div>
    </v-container>
  </v-content>
</template>

<script>
export default {
  name: "success",
  data() {
    return {
      items: [],
    };
  },
};
</script>

